<template>
  <div class="height100">
    <div class="logo">
      <img class="logo-img" :src="logo" alt="HealthyWage logo" />
    </div>
    <div class="prize-calculator-header">Prize Calculator</div>

    <slot></slot>
  </div>
</template>

<script>

import { STATIC_URL } from '../main';

export default {
  data() {
    return {
      logo: `${STATIC_URL}img/logo-by-healthywager.png`
    }
  }
};
</script>
